import type { SchedulingPerformanceKpis } from '@services/api/dashboard/scheduling-performance.api'
import type { DashboardMetricItemData } from '../types/dashboardMetrics.types'

export function mapSchedulingPerformanceOverviewMetrics(
  kpis: SchedulingPerformanceKpis,
): DashboardMetricItemData[] {
  return [
    {
      id: 'scheduled-appointments',
      leftLabel: 'Scheduled appointments',
      value: kpis.scheduledAppointments,
    },
    {
      id: 'scheduled-patients',
      leftLabel: 'Scheduled patients',
      value: kpis.scheduledPatients,
    },
    {
      id: 'scheduled-production',
      leftLabel: 'Scheduled production',
      value: kpis.scheduledProduction,
    },
    {
      id: 'broken-appointments',
      leftLabel: 'Broken appointments',
      value: kpis.brokenAppointments,
    },
    { id: 'no-show', leftLabel: 'No-show', value: kpis.noShow },
    {
      id: 'reschedule-rate',
      leftLabel: 'Reschedule rate',
      value: kpis.rescheduleRate,
    },
  ]
}

export function mapSchedulingPerformanceOperatoryMetrics(
  kpis: SchedulingPerformanceKpis,
): DashboardMetricItemData[] {
  return [
    {
      id: 'schedule-utilization',
      leftLabel: 'Schedule utilization',
      value: kpis.scheduleUtilization,
    },
    { id: 'open-hours', leftLabel: 'Open hours', value: kpis.openHours },
    {
      id: 'total-worked-days',
      leftLabel: 'Total worked days',
      value: kpis.totalWorkedDays,
    },
    {
      id: 'missing-procedure-codes',
      leftLabel: 'Missing procedure codes',
      value: kpis.missingProcedureCodes,
    },
    {
      id: 'unassn-procedures',
      leftLabel: 'Unassigned procedures',
      value: kpis.unassnProcedures,
    },
    {
      id: 'schedules-wo-code',
      leftLabel: 'Schedules w/o code',
      value: kpis.schedulesWoCode,
    },
  ]
}
